module.exports = __webpack_public_path__ + "img/logo.33df94c1.png";